








import CommonBase from "../CommonBase";
import {Component} from "vue-property-decorator";
import LastRegsCard from "./LastRegsCard.vue";

@Component({
    components: {
        "at-last-regs-card": LastRegsCard,
    }
})
export default class UserReghistPage extends CommonBase {
}
